<template>
  <li>
    <div class="product-container">
      <quantity
        class="quantity"
        :quantity="quantity"
        @setQuantity="$emit('set-quantity', $event)"
        :editable="!product.volumeQuantity > 0 && editable"
      ></quantity>

      <div class="image pointer" @click="goToProduct">
        <package-thumbnail
          v-if="product.type === 'package'"
          :product="product"
        ></package-thumbnail>

        <product-thumbnail v-else :product="product"></product-thumbnail>
      </div>
      <div class="name pointer" @click="goToProduct">
        <span>{{ product.name }}</span>
      </div>

      <div class="specs" v-if="product.type === 'package'">
        <span>Kant-en-klaar pakket</span>
      </div>
      <div class="specs" v-else>
        <span
          v-for="(spec, name) in printSpecification"
          :key="name"
          class="spec"
        >
          {{ spec }}
        </span>
      </div>

      <div class="price" v-if="product.price">
        <h4>Prijs</h4>
        <span class="">{{ productPrice }}</span>
      </div>
      <button
        class="remove-file"
        :class="{ 'auto-margin': !product.price }"
        @click.stop="removeProduct(product)"
        v-if="editable"
      >
        <svg class="trash" width="15px" height="15px" viewBox="0 0 15 15">
          <title>Verwijderen</title>
          <g id="prullenmand">
            <path
              fill="#4f4f4f"
              d="M3,4 L3,13.25 C3,13.6642136 3.3581722,14 3.8,14 L10.2,14 C10.6418278,14 11,13.6642136 11,13.25 L11,4 L3,4 Z M9,2 L13,2 L13,3 L12,3 L12,13.4285714 C12,14.2964475 11.2538079,15 10.3333333,15 L3.66666667,15 C2.74619208,15 2,14.2964475 2,13.4285714 L2,3 L1,3 L1,2 L5,2 L5,1 C5,0.44771525 5.44771525,1.01453063e-16 6,0 L8,0 C8.55228475,-1.01453063e-16 9,0.44771525 9,1 L9,2 Z M5,6 L5,12 L6,12 L6,6 L5,6 Z M8,6 L8,12 L9,12 L9,6 L8,6 Z"
            ></path>
          </g>
        </svg>
      </button>
    </div>
  </li>
</template>

<script>
import PackageThumbnail from '@/components/PackageImageThumbnail.vue'
import ProductThumbnail from '@/components/ProductThumbnail'
import Quantity from '@/components/ui/ProductQuantity.vue'
import { isVNode } from 'vue'

export default {
  props: ['product', 'editable'],
  components: {
    PackageThumbnail,
    ProductThumbnail,
    Quantity
  },
  computed: {
    printSpecification() {
      let specs = { ...this.product.printSpecification }
      delete specs['info']
      return specs
    },
    productPrice() {
      if (this.product.volumeQuantity) {
        return '€ ' + this.product.price
      }
      let full = this.product.quantity * this.product.price
      full = full.toFixed(2).replace('.', ',')
      return '€ ' + full
    },
    quantity() {
      return this.product.volumeQuantity
        ? this.product.volumeQuantity
        : this.product.quantity
    }
  },
  methods: {
    removeProduct(product) {
      this.$emit('remove', product)
    },
    goToProduct() {
      if (this.product.type === 'package') {
        this.$router.push({
          name: 'printStorePackage',
          params: {
            categoryId: this.product.categoryId,
            packageId: this.product.id
          }
        })
      } else {
        const paramObject = {
          categoryId: this.product.categoryId,
          collectionId: this.product.collectionId,
          productId: this.product.id,
          currentSpecs: this.product.printSpecification
        }

        if (this.product.isCustomizable) {
          paramObject.customFields = this.product.customFields
        }

        this.$router.push({
          name: 'printStoreProduct',
          params: paramObject
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.quantity {
  container-type: normal;
}
li {
  height: 65px;
  box-shadow: var(--default-shadow);
  border-radius: 32px;
  padding: 0 25px;
  margin-bottom: 20px;
}
.product-container {
  display: flex;
  height: 100%;
  // min-height: 52px;
  align-items: center;

  & > div {
    padding-right: 20px;

    &:last-child {
      padding-right: 0;
    }
  }
}

.name {
  font-weight: 600;
  padding-right: 10px;
}

.specs {
  //flex-grow: 1;
}

.spec {
  padding-right: 5px;
}

.image {
  padding-right: 10px;
}

.quantity {
  padding-right: 20px;
}

.price {
  //  font-weight: 600;
  //flex: 0 0 85px;
  //padding-left: 15px;
  //text-align: right;
  margin-left: auto;
}

.auto-margin {
  margin-left: auto;
}

h4 {
  display: inline-block;
  font-weight: 600;
  padding-right: 10px;
}
</style>
